import { MsalInterceptorConfiguration } from '@azure/msal-angular';
import { InteractionType } from '@azure/msal-browser';
import { EnvironmentProfile } from '@utils/interfaces';

export function createProtectedResourceMap(profile: EnvironmentProfile): MsalInterceptorConfiguration {
  const protectedResourceMap = new Map<string, string[]>();
  protectedResourceMap.set(`${profile.api}/rest/*`, [`${profile.msalConfig.auth.clientId}/art.access`]);
  protectedResourceMap.set(`${profile.api}/art/*`, [`${profile.msalConfig.auth.clientId}/art.access`]);

  return {
    interactionType: InteractionType.Redirect,
    protectedResourceMap,
  };
}
